import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { AcquisitionSystemItemVM } from 'practice/view-models/acquisition-system-list';
import { memo, useEffect } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { AcquisitionSystemData } from 'shell/models/practice-lists';
import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';

export enum CodiceDominioPraticaTipo11 {
  OsservazioniNegative = 'C',
}

interface PracticeTextListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (value?: string, item?: AcquisitionSystemItemVM) => void;
  error?: boolean;
  label?: string;
  id?: string;
  typePractice?: number;
}

const PracticeTextListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Testo Pratica',
  id = 'practice-text-list',
  typePractice = 1,
}: PracticeTextListComponentProps): React.ReactElement => {
  const [list, getList] = useHttpFetch<
    HttpResponseList<AcquisitionSystemData>,
    Array<AcquisitionSystemItemVM>
  >(`${__PRACTICE_API_URL__}/pratiche/dominio-pratiche`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: (response: AxiosResponse<HttpResponseList<AcquisitionSystemData>>) => {
      const { data } = response;
      return data?.payload.list?.map((item) => ({
        id: item.key?.codiceDominioPratica || '',
        value: item.descrizioneValore || '',
        descriptionValue: item.testoValore || '',
      }));
    },
  });

  useEffect(() => {
    const data = {
      tipoDominioPratica: { value: typePractice, operation: Operation.EQUALS },
    };

    const queryParams = `${paginationListToQueryString({
      filters: data,
      orders: {},
    })}`;

    getList({
      params: {},
      paramsSerializer: () => queryParams,
    });
  }, [typePractice]);

  const idTag = `${id}-${label}`;

  const listDomain = (list.data as Array<AcquisitionSystemItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          const item = listDomain.find((element) => element.id === selectedValue);
          onChange(selectedValue, item);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {listDomain?.map((item: AcquisitionSystemItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

PracticeTextListComponent.displayName = 'PracticeText List component';

const PracticeTextList = memo(PracticeTextListComponent);

export default PracticeTextList as typeof PracticeTextListComponent;
